import { Locale } from "../lib/i18n/i18n_provider";

export enum Hebrew {
  label = "עברית",
  value = "he-IL",
}

export enum English {
  label = "English",
  value = "en-US",
}

export enum Polish {
  label = "Polski",
  value = "pl-PL",
}

export enum Spanish {
  label = "Español",
  value = "es-ES",
}

export const enLocale: Locale = {
  languageTag: "en-US",
  baseLanguageTag: "en",
  direction: "ltr",
};

export const heLocale: Locale = {
  languageTag: "he-IL",
  baseLanguageTag: "he",
  direction: "rtl",
};

export const plLocale: Locale = {
  languageTag: "pl-PL",
  baseLanguageTag: "pl",
  direction: "ltr",
};

export const esLocale: Locale = {
  languageTag: "es-ES",
  baseLanguageTag: "es",
  direction: "ltr",
};

export const localesByLanguage: {
  [locale: string]: Locale;
} = {
  en: enLocale,
  "en-US": enLocale,
  he: heLocale,
  "he-IL": heLocale,
  pl: plLocale,
  "pl-PL": plLocale,
  es: esLocale,
  "es-ES": esLocale,
};

export interface LocaleOption {
  label: string;
  value: string;
}
